import { render, staticRenderFns } from "./DefaultTrafficReport.vue?vue&type=template&id=f3dbcfa6&scoped=true"
import script from "./DefaultTrafficReport.vue?vue&type=script&lang=js"
export * from "./DefaultTrafficReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3dbcfa6",
  null
  
)

export default component.exports